<div class="modal-parent-container">
    <div class="survey-container">
        <h1>Newly Added Survey</h1>
        <div class="survey-list">
            <div class="survey-content form-check" *ngFor="let survey of data.surveys">
                <input class="form-check-input" [checked]="survey.checked" (change)="surveyChecked($event.currentTarget ,survey.id, survey.survey_email_map_id)" type="checkbox" class="form-check-input">
                <span>{{ survey.alias }}</span>
            </div>
        </div>
    </div>
    <div class="emails-container">
        <h1>Send Mail To</h1>
        <div class="search-box">
            <!-- <img src="../../../../../assets/media/icons/info copy 2.png" alt=""> -->
            <input type="text" placeholder="Search..." [(ngModel)]="filterText" (input)="filterMails()">
        </div>
        <div class="email-list">
            <div class="left-content">
                <div class="email-content" *ngFor="let left of emails.left">
                    <input type="checkbox" class="form-check-input" [checked]="left.checked" (change)="emailChecked($event.currentTarget ,left.email,left.index)">
                    <span>{{ left.email }}</span>
                </div>
            </div>
            <div class="right-content">
                <div class="email-content" *ngFor="let right of emails.right">
                    <input type="checkbox" class="form-check-input" [checked]="right.checked" (change)="emailChecked($event.currentTarget ,right.email,right.index)">
                    <span>{{ right.email }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="footer">
        <div class="action-btns">
            <button class="btn btn-secondary btn-inventory fs-6 py-3" (click)="close()">Cancel</button>
            <button class="btn btn-primary btn-inventory fs-6 py-3" (click)="sendMail()">Send</button>
        </div>
    </div>
</div>
